import {SidebarMenuItem} from '../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem'
import {SidebarMenuItemWithSub} from '../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub'
import {useAuth} from '../../hooks/useAuth'

/* eslint-disable react/jsx-no-target-blank */
const KSideBarMenuApps = () => {
  const {applications} = useAuth()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Aplicaciones</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/panel'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Panel'
        fontIcon='bi-layers'
      />
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Otras Aplicaciones'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        {applications.map((app: any) => (
          <SidebarMenuItem to={app.path} title={app.label} hasBullet={true} key={app.label} />
        ))}
      </SidebarMenuItemWithSub>
    </>
  )
}

export {KSideBarMenuApps}
